// 휴대폰 목업 안에 들어가는 실제 앱 캡처. 배열 순서가 미리보기 슬라이드 순서다.
import MydHome from "./myd/01_home.webp";
import MydConnect from "./myd/02_connect.webp";
import MydView from "./myd/03_view.webp";
import MydBenefit from "./myd/04_benefit.webp";
import MydHistory from "./myd/05_history.webp";
import MydPoint from "./myd/06_point.webp";
import MydAttendance from "./myd/07_attendance.webp";
import MydPedometer from "./myd/08_pedometer.webp";
import MydChallenge from "./myd/09_challenge.webp";
import MydShopping from "./myd/10_shopping.webp";
import MydMyShopping from "./myd/11_myshopping.webp";
import MydBrandTicket from "./myd/12_brandticket.webp";
import MydTravel from "./myd/13_travel.webp";
import MydMy from "./myd/14_my.webp";

import StockHome from "./mystock/01_home.webp";
import StockSearch from "./mystock/02_search.webp";
import StockWrite from "./mystock/03_write.webp";
import StockDetail from "./mystock/04_detail.webp";
import StockActivityPosts from "./mystock/05_activity_posts.webp";
import StockActivityComments from "./mystock/06_activity_comments.webp";
import StockGuest from "./mystock/07_guest.webp";
import StockLogin from "./mystock/08_login.webp";

export interface Capture {
    src: string;
    alt: string;
}

export const MYD_CAPTURES: Capture[] = [
    { src: MydHome, alt: "마이디 홈" },
    { src: MydConnect, alt: "마이디 연결" },
    { src: MydView, alt: "마이디 조회" },
    { src: MydBenefit, alt: "마이디 혜택" },
    { src: MydHistory, alt: "마이디 참여 내역" },
    { src: MydPoint, alt: "마이디 포인트" },
    { src: MydAttendance, alt: "마이디 출석체크" },
    { src: MydPedometer, alt: "마이디 만보기" },
    { src: MydChallenge, alt: "마이디 챌린지" },
    { src: MydShopping, alt: "마이디 쇼핑" },
    { src: MydMyShopping, alt: "마이디 마이쇼핑" },
    { src: MydBrandTicket, alt: "마이디 브랜드티켓" },
    { src: MydTravel, alt: "마이디 여행/레저" },
    { src: MydMy, alt: "마이디 마이" },
];

export const MYSTOCK_CAPTURES: Capture[] = [
    { src: StockHome, alt: "마이주식 홈" },
    { src: StockSearch, alt: "마이주식 종목 검색" },
    { src: StockWrite, alt: "마이주식 글쓰기" },
    { src: StockDetail, alt: "마이주식 게시글 상세" },
    { src: StockActivityPosts, alt: "마이주식 내 활동 - 남긴 글" },
    { src: StockActivityComments, alt: "마이주식 내 활동 - 남긴 댓글" },
    { src: StockGuest, alt: "마이주식 둘러보기" },
    { src: StockLogin, alt: "마이주식 간편 로그인" },
];
